import { Drawer, Row } from "antd";
import { isDesktop } from "react-device-detect";
import ExpandableText from "../../components/ExpandableText";

interface DrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  collab: any;
}

const DrawerInstructions: React.FC<DrawerProps> = (props) => {
  const { open, setOpen, collab } = props;
  return (
    <Drawer
      placement="bottom"
      rootClassName="drawer-rating"
      title="Instructions"
      onClose={() => setOpen(false)}
      open={open}
      // style={{ width: 400 }}
      classNames={{
        header: "collabs-drawer-header",
        body: "collabs-drawer-body collab-detail",
      }}
      styles={{
        header: {
          border: "none",
          // width: 400,
        },
        // content: {
        //   alignItems: "center",
        // },
        body: {
          marginLeft: isDesktop ? 265 : 0,
          justifyContent: "center",
          display: "flex",
        },
      }}
      height={700}
    >
      <Row>
        <div
          className="briefing"
          style={{ marginBottom: 80, marginTop: 0, minWidth: 250 }}
        >
          <span className="title">Brief:</span>
          <ExpandableText text={collab.focusPoints} collapsedHeight={240} />

          <span className="title">Deliverables:</span>
          <ul>
            {collab?.deliverables?.instagramReel && (
              <li className="circle checkmark">Instagram Reel</li>
            )}
            {collab?.deliverables?.instagramStory && (
              <li className="circle checkmark">Instagram Story</li>
            )}
            {collab?.deliverables?.tiktokVideo && (
              <li className="circle checkmark">TikTok Video</li>
            )}
          </ul>
        </div>
      </Row>
    </Drawer>
  );
};

export default DrawerInstructions;
